module.exports = __webpack_public_path__ + "static/img/category.12291a5f.png";